<form [formGroup]="reform" (ngSubmit)="onSave()">
  <h2>{{ "reforms.titleEdit" | translate }}</h2>
  <div formGroupName="reforma">
    <label id="reMarcolegal" for="reMarcolegal">Marco legal</label>

    <input
      type="text"
      formControlName="reMarcolegal"
      [readonly]="true"
      maxlength="32"
    />

    <label id="reId" for="reId">Identificador</label>

    <input type="text" formControlName="reId" [readonly]="true" maxlength="8" />

    <label id="reDescr" for="reDescr">Descripción</label>

    <input
      type="text"
      formControlName="reDescr"
      [readonly]="true"
      maxlength="32"
    />

    <label id="reTramitable" for="reTramitable">Es tramitable</label>

    <input
      type="checkbox"
      style="cursor: pointer !important"
      formControlName="reTramitable"
      maxlength="32"
    />

    <label id="reActivarOcultos" for="reActivarOcultos"
      >Activar campos ocultos
    </label>

    <input
      type="checkbox"
      style="cursor: pointer !important"
      formControlName="reActivarOcultos"
    />
  </div>
  <h2>Selección de los ficheros de ayuda en los idiomas soportados</h2>
  <div formGroupName="ayudaEspanolDto">
    <label id="ayFichero" for="ayFichero">Español</label>
    <input
      type="file"
      (change)="handleFileInputEsp($event)"
      formControlName="ayFichero"
    />
  </div>
  <p *ngIf="files.en != '' && this.reform.value.ayudaInglesDto.id != ''">
    Fichero cargado previamente{{ files.es }}
  </p>
  <button
    type="button"
    *ngIf="files.es != '' && this.reform.value.ayudaEspanolDto.id != ''"
    (click)="download(this.reform.value.ayudaEspanolDto.id, files.es)"
  >
    Descarga
  </button>
  <div formGroupName="ayudaInglesDto">
    <label id="ayFichero" for="ayFichero">Ingles</label>
    <input
      type="file"
      (change)="handleFileInputEng($event)"
      formControlName="ayFichero"
    />
  </div>
  <p *ngIf="files.en != '' && this.reform.value.ayudaInglesDto.id != ''">
    Fichero cargado previamente{{ files.en }}
  </p>
  <button
    type="button"
    *ngIf="files.en != '' && this.reform.value.ayudaInglesDto.id != ''"
    (click)="download(this.reform.value.ayudaInglesDto.id, files.en)"
  >
    Descarga
  </button>
  <div></div>
  <button type="submit">{{ "commons.update" | translate }}</button>
  <button *ngIf="reform.pristine" type="button" (click)="goList()">
    {{ "commons.back" | translate }}
  </button>
  <swal
    #confirmSwal
    html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
    icon="warning"
    [showCancelButton]="true"
    [swalOptions]="{
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      allowEscapeKey: false,
      allowOutsideClick: false
    }"
    [focusCancel]="true"
    (confirm)="goList()"
  >
  </swal>
  <button
    class="submitButton"
    type="button"
    *ngIf="!reform.pristine"
    [swal]="confirmSwal"
  >
    {{ "commons.back" | translate }}
  </button>
</form>
